@import (reference) '../../../constants/spacing.module.less';

.overview-grid-layout {
  flex: 1;
  display: grid;
  grid-template:
    'shipment-details customer-information'
    'shipment-items shipment-items';
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 2fr 1fr;
  gap: @space-16 @space-32;
}

.shipment-details {
  grid-area: shipment-details;
}

.label-history {
  grid-area: customer-information;
}

.shipment-items {
  grid-area: shipment-items;
}
